(function(){
  'use strict';
  const instances = new Map();
  const reduce = (window.SaguaroMotion ? window.SaguaroMotion() : matchMedia('(prefers-reduced-motion: reduce)'));

  function maskName(value){
    return String(value || '').trim().split(/\s+/).filter(Boolean).map(part => {
      if(part.includes('*')) return part;
      const letters = Array.from(part.replace(/[.]/g, ''));
      return letters[0] + '*'.repeat(Math.max(1, Math.min(letters.length - 1, 7)));
    }).join(' ');
  }

  function init(root){
    if(instances.has(root)) return;
    const rail = root.querySelector('.m07-review-rail');
    if(!rail) return;
    const controller = new AbortController();
    const { signal } = controller;
    const cards = () => Array.from(rail.querySelectorAll('.m07-review-card'));
    const pauseControl = root.querySelector('[data-review-pause]');
    let frame=0,lastTime=0,position=rail.scrollLeft,visible=false,hover=false,dragging=false,manualPause=false,resumeAt=0,endAt=0;
    function automatic(){return root.dataset.autoScroll!=='false'&&!reduce.matches&&!document.hidden&&visible&&!hover&&!dragging&&!manualPause&&!rail.contains(document.activeElement);}
    function tick(now){
      frame=0;
      if(!automatic()){lastTime=0;position=rail.scrollLeft;rail.classList.remove('is-auto-scrolling');return;}
      rail.classList.add('is-auto-scrolling');
      if(!lastTime)position=rail.scrollLeft;
      const elapsed=lastTime?Math.min(now-lastTime,50):0;lastTime=now;
      const max=rail.scrollWidth-rail.clientWidth;
      if(max>2 && now>=resumeAt){
        if(rail.scrollLeft>=max-1){if(!endAt)endAt=now+2200;if(now>=endAt){rail.scrollLeft=0;position=0;endAt=0;resumeAt=now+1200;}}
        else{endAt=0;position=Math.min(max,position+elapsed*(Number(root.dataset.scrollSpeed)||24)/1000);rail.scrollLeft=position;}
      }else if(now<resumeAt){position=rail.scrollLeft;}
      frame=requestAnimationFrame(tick);
    }
    function sync(){if(!frame)frame=requestAnimationFrame(tick);}
    const visibleObserver=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.15});
    visibleObserver.observe(rail);
    pauseControl?.addEventListener('click',()=>{manualPause=!manualPause;pauseControl.setAttribute('aria-pressed',String(manualPause));pauseControl.setAttribute('aria-label',manualPause?'Riprendi scorrimento':'Pausa scorrimento');pauseControl.textContent=manualPause?'▷':'Ⅱ';sync();},{signal});
    rail.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){hover=true;sync();}},{signal});
    rail.addEventListener('pointerleave',()=>{hover=false;sync();},{signal});
    rail.addEventListener('pointerdown',()=>{dragging=true;sync();},{signal});
    window.addEventListener('pointerup',()=>{if(dragging){dragging=false;resumeAt=performance.now()+5000;sync();}},{signal});
    window.addEventListener('pointercancel',()=>{dragging=false;resumeAt=performance.now()+5000;sync();},{signal});
    rail.addEventListener('wheel',()=>{resumeAt=performance.now()+5000;},{passive:true,signal});
    rail.addEventListener('focusin',sync,{signal});rail.addEventListener('focusout',()=>queueMicrotask(sync),{signal});
    document.addEventListener('visibilitychange',sync,{signal});reduce.addEventListener('change',sync,{signal});

    function updateMedia(card){
      const img = card.querySelector('.m07-review-image');
      const caption = card.querySelector('.m07-review-source');
      const product = (window.SAGUARO_CATALOG || []).find(item => item.id === card.dataset.productId);
      const link = card.querySelector('.m07-review-product');
      if(product){
        if(link.textContent !== product.name) link.textContent = product.name;
        link.href = product.url;
      }
      const customer = img.dataset.customerImage || '';
      const fallback = img.dataset.sceneImage || (product && product.scene && product.scene.image) || '';
      const customerMode = Boolean(customer && img.dataset.failedCustomer !== customer);
      const source = customerMode ? customer : fallback;
      img.hidden = !source || img.dataset.failedScene === source;
      if(!img.hidden && img.getAttribute('src') !== source) img.setAttribute('src', source);
      img.alt = customerMode ? (img.dataset.customerAlt || 'Foto del cliente') : ((product && product.scene && product.scene.alt) || 'Prodotto in uso');
      const label = caption.dataset.sourceLabel || (customerMode ? root.dataset.customerLabel : root.dataset.sceneLabel);
      if(caption.textContent !== label) caption.textContent = label;
      card.dataset.mediaKind = customerMode ? 'customer' : 'product';
    }

    function refresh(){
      cards().forEach(card => {
        const name = card.querySelector('.m07-review-name');
        const masked = maskName(name.textContent);
        if(name.textContent !== masked) name.textContent = masked;
        const score = Math.max(1, Math.min(5, Number(card.dataset.rating) || 5));
        const rating = card.querySelector('.m07-review-rating');
        const stars = '★'.repeat(score) + '☆'.repeat(5 - score);
        if(rating.textContent !== stars) rating.textContent = stars;
        rating.setAttribute('aria-label', score + ' su 5 stelle');
        updateMedia(card);
        const quote = card.querySelector('.m07-review-text');
        const button = card.querySelector('.m07-read-more');
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.hidden = !expanded && quote.scrollHeight <= quote.clientHeight + 2;
        const label = expanded ? root.dataset.lessLabel : root.dataset.moreLabel;
        if(button.textContent !== label) button.textContent = label;
      });
    }

    function scrollToCard(index){
      const all = cards();
      if(!all.length) return;
      const target = all[Math.max(0, Math.min(all.length - 1, index))];
      target.scrollIntoView({behavior: reduce.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'start'});
    }

    root.addEventListener('click', event => {
      const button = event.target.closest('.m07-read-more');
      if(!button) return;
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      button.closest('.m07-review-card').classList.toggle('is-expanded', expanded);
      refresh();
    }, {signal});

    rail.addEventListener('error', event => {
      const img = event.target;
      if(!img.matches('.m07-review-image')) return;
      const card = img.closest('.m07-review-card');
      if(card.dataset.mediaKind === 'customer') img.dataset.failedCustomer = img.dataset.customerImage;
      else img.dataset.failedScene = img.getAttribute('src');
      updateMedia(card);
    }, {capture: true, signal});

    rail.addEventListener('keydown', event => {
      if(event.target !== rail || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
      const all = cards();
      if(!all.length) return;
      event.preventDefault();
      const railBox = rail.getBoundingClientRect();
      const current = all.reduce((best, card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - railBox.left);
        return distance < best.distance ? {index, distance} : best;
      }, {index: 0, distance: Infinity}).index;
      if(event.key === 'Home') scrollToCard(0);
      else if(event.key === 'End') scrollToCard(all.length - 1);
      else scrollToCard(current + (event.key === 'ArrowRight' ? 1 : -1));
    }, {signal});

    const resize = new ResizeObserver(refresh);
    resize.observe(rail);
    const observer = new MutationObserver(refresh);
    observer.observe(rail, {subtree: true, childList: true, attributes: true, attributeFilter: ['data-customer-image', 'data-scene-image', 'data-product-id', 'data-rating']});
    document.addEventListener('saguaro:product-media-change', refresh, {signal});
    instances.set(root, () => {
      controller.abort();
      cancelAnimationFrame(frame);visibleObserver.disconnect();rail.classList.remove('is-auto-scrolling');
      observer.disconnect();
      resize.disconnect();
    });
    refresh();
  }

  function boot(scope){
    if(scope.matches && scope.matches('.m07-reviews')) init(scope);
    if(scope.querySelectorAll) scope.querySelectorAll('.m07-reviews').forEach(init);
  }

  window.SaguaroReviews = {maskName};
  boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((dispose, root) => {
      if(root === event.target || event.target.contains(root)){
        dispose();
        instances.delete(root);
      }
    });
  });
  window.addEventListener('pagehide', event => {
    if(!event.persisted){
      instances.forEach(dispose => dispose());
      instances.clear();
    }
  });

  // The verified Testimonials section has fixed markup. Keep the behavior
  // additive so its Shopify schema and saved block data remain untouched.
  const testimonialInstances = new Map();
  function initTestimonials(root){
    if(testimonialInstances.has(root)) return;
    const rail=root.querySelector('.testimonials__grid');
    if(!rail) return;
    const controller=new AbortController();
    const {signal}=controller;
    let frame=0,last=0,position=rail.scrollLeft,endAt=0;
    function tick(now){
      frame=0;
      const max=rail.scrollWidth-rail.clientWidth;
      const elapsed=last?Math.min(now-last,50):0;
      last=now;
      if(max<=2){ last=0; return; }
      if(rail.scrollLeft>=max-1){
        if(!endAt) endAt=now+2200;
        if(now>=endAt){rail.scrollLeft=0;position=0;endAt=0;}
      }else if(max>2){
        endAt=0;
        position=Math.min(max,position+(elapsed*20/1000));
        rail.scrollLeft=position;
      }
      frame=requestAnimationFrame(tick);
    }
    function resume(){if(!frame) frame=requestAnimationFrame(tick);}
    const resizeObserver = window.ResizeObserver ? new ResizeObserver(resume) : null;
    if(resizeObserver) resizeObserver.observe(rail);
    testimonialInstances.set(root,()=>{controller.abort();cancelAnimationFrame(frame);if(resizeObserver) resizeObserver.disconnect();});
    resume();
  }
  function bootTestimonials(scope){
    if(scope.matches?.('.testimonials')) initTestimonials(scope);
    scope.querySelectorAll?.('.testimonials').forEach(initTestimonials);
  }
  bootTestimonials(document);
  document.addEventListener('shopify:section:load',event=>bootTestimonials(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    testimonialInstances.forEach((dispose,root)=>{
      if(root===event.target||event.target.contains(root)){dispose();testimonialInstances.delete(root);}
    });
  });
}());
